import { Platform } from 'react-native';

export default function getMobileBrowserPlatform() {
  if (Platform.OS !== 'web') return null;
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return null;
}
